/* unplugin-vue-components disabled */import script from "./NavList.vue?vue&type=script&setup=true&lang=js"
export * from "./NavList.vue?vue&type=script&setup=true&lang=js"

import "./NavList.vue?vue&type=style&index=0&id=2f678e25&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f678e25"]])

export default __exports__